import { memo } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import ConfirmModal from 'components/ConfirmModal';

const CheckInOutOfRangeModal = memo(({ isOpen, onConfirm, onClose }) => {
    return (
        <ConfirmModal
            className="fm-confirm-modal-check-in-out-of-range"
            isOpen={isOpen}
            title={getLiteral('helptext_confirm')}
            confirmText={getLiteral('common_yes')}
            cancelText={getLiteral('action_cancel')}
            onConfirm={onConfirm}
            onClose={onClose}
        >
            <div className="confirm-check-in-out-of-range-modal-container">
                <Text>{getLiteral('label_modal_outofrange')}</Text>
            </div>
        </ConfirmModal>
    );
});

CheckInOutOfRangeModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default CheckInOutOfRangeModal;
